import React from 'react'

import { Tooltip } from 'slab'

import { type IngestionJob } from './types'

export const IngestionJobProgressBar: React.FC<{ job: IngestionJob }> = ({ job }) => {
  const totalExpected = job.expected_states_count || job.total_states
  const succeeded = job.succeeded_count
  const failed = job.failed_count
  const cancelled = job.cancelled_count
  const processing = job.processing_count
  const pending = job.pending_count
  const processed = succeeded + failed + cancelled + processing + pending

  const notStarted = Math.max(0, totalExpected - processed)

  const percentSuccess = totalExpected > 0 ? (succeeded / totalExpected) * 100 : 0
  const percentFailed = totalExpected > 0 ? (failed / totalExpected) * 100 : 0
  const percentCancelled = totalExpected > 0 ? (cancelled / totalExpected) * 100 : 0
  const percentProcessing = totalExpected > 0 ? (processing / totalExpected) * 100 : 0
  const percentPending = totalExpected > 0 ? (pending / totalExpected) * 100 : 0
  const percentNotStarted = totalExpected > 0 ? (notStarted / totalExpected) * 100 : 0

  return (
    <Tooltip
      content={
        <div className='text-xs'>
          <div>Succeeded: {succeeded}/{totalExpected}</div>
          <div>Failed: {failed}/{totalExpected}</div>
          {cancelled > 0 && <div>Cancelled: {cancelled}/{totalExpected}</div>}
          {processing > 0 && <div>Processing: {processing}/{totalExpected}</div>}
          {pending > 0 && <div>Pending: {pending}/{totalExpected}</div>}
          {notStarted > 0 && <div>Not Started: {notStarted}/{totalExpected}</div>}
        </div>
      }
    >
      <div className='w-full h-2 bg-gray-200 rounded-full overflow-hidden flex'>
        <div
          className='bg-green-400 h-full transition-all'
          style={{ width: `${percentSuccess}%` }}
        />
        <div
          className='bg-yellow-400 h-full transition-all'
          style={{ width: `${percentProcessing}%` }}
        />
        <div
          className='bg-blue-400 h-full transition-all'
          style={{ width: `${percentPending}%` }}
        />
        <div
          className='bg-orange-400 h-full transition-all'
          style={{ width: `${percentCancelled}%` }}
        />
        <div
          className='bg-red-300 h-full transition-all'
          style={{ width: `${percentFailed}%` }}
        />
        <div
          className='bg-gray-300 h-full transition-all'
          style={{ width: `${percentNotStarted}%` }}
        />
      </div>
    </Tooltip>
  )
}
